/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import * as MODALS from "../modals";
import * as DATA from "../elements";
import * as API from "../../http/api";
import DataTable from "react-data-table-component";
import { openlightbox } from "../../util/Functions";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles2 } from "../../util/TableStyles"
import { status, noDataComponent } from "../../util/DataObject"
import { ContactPageSharp, AddLink, People, GroupAdd, Search, ForwardToInbox, MarkEmailRead, AdminPanelSettings, LeakRemove, AdbOutlined, QrCodeScanner } from "@mui/icons-material";
import { IconButton, Tooltip, TextField } from "@mui/material";
import { FlexGrid, Typography, Card, useDialog } from '@albo-ui/core';
import GeneralConfirmDialog from "../modals/confirm/GeneralConfirmDialog";

const AdminAbbList = (props) => {
  const history = useHistory();
  const [list, setList] = useState([]);
  const [limit, setLimit] = useState(100);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [oldList, setOldList] = useState([]);
  const [roles, setRoles] = useState([]);
  const [search, setSearch] = useState("");

  const dialogProps = useDialog();
  const [action, setSAction] = useState("");
  const [element, setElement] = useState(null);
  const [dialogText, setDialogText] = useState({});
  const [item, setItem] = useState(null);
  
  const onOpenConfirm = (row, action) => {
    setItem(row);
    switch (action) {
      case "resendEmail":
        setElement([
          {type: "textField", label: "UUID", key: "session_uuid", text: "Por favor ingresa el UUID de la sesión para continuar."}
        ])
        setDialogText({
          title: "Reenviar correo",
          message: "¿Estás seguro que deseas reenviar el correo de confirmación 3FA al siguiente Administrador?"
        })
        break;
      case "restoreSession":
        let checkOptions = [
          {label: 'Sí soy yo el que intentó ingresar a mi cuenta', value: "whitelist", color: "info"},
          {label: 'No soy yo quien está intentando ingresar a mi cuenta', value: "blacklist", color: "warning"},
        ]
        setElement([
          {type: "textField", label: "UUID", key: "session_uuid"}, 
          {type: "checkBox", options: checkOptions, key: "action"}
        ])
        setDialogText({
          title: "Validar sesión",
          message: "A continuación complete el UUID de la sesión e indique si es válida para el siguiente Administrador"
        })
        break;
      case "resendEmailCS":
        setDialogText({
          title: "Reenviar correo",
          message: "¿Estás seguro que deseas reenviar el correo de confirmación 3FA al siguiente Administrador?"
        })
        break;
      case "otpTokenDisabledConfirm":
        setDialogText({
          title: "¿Estas seguro que deseas desvincular el albo token?",
          message: "Al desvincular el albo token, el usuario perderá acceso. Será necesario vincularlo nuevamente para poder utilizarlo de nuevo."
        })
        break;
      case "onInsertAlboToken":
        setDialogText({
          title: "¿Estás seguro que deseas habilitar albo token?",
          message: "Se habilitará albo token en la plataforma para autorizar las operaciones al siguiente cliente.",
          cancelButton: "No, cancelar",
          confirmButton: "Sí, habilitar"
        })
        break;
      case "onInsertAlboTokenByEmail":
        setDialogText({
          title: "¿Estás seguro que deseas activar albo token vía email?",
          message: "A continuación se enviará un código de autenticación al cliente para vincular albo token vía email.",
          cancelButton: "No, cancelar",
          confirmButton: "Sí, vincular"
        })
        break;
    }
    setSAction(action);
    dialogProps.openDialog();
  };
  const onHandleConfirm = (result) => {
    dialogProps.onClose();
    switch (action) {
      case 'resendEmail':
        return resendEmail(result);
      case 'restoreSession':
        return restoreSession(result);
      case 'resendEmailCS':
        return resendEmailCS();
      case 'otpTokenDisabledConfirm':
        return otpTokenDisabledConfirm();
      case 'onInsertAlboToken':
        return onInsertAlboToken();
      case 'onInsertAlboTokenByEmail':
        return onInsertAlboTokenByEmail();
    };
  };
  const onCloseDialogConfirm = () => {
    dialogProps.onClose();
    resetFields();
  };
  const resetFields = () => {
    setSAction("");
    setElement(null);
    setDialogText({});
    setItem(null);
  };

  useEffect(() => {
    init();
  }, [props.content]);

  const init = () => {
    setList(JSON.parse(JSON.stringify(props.content.users)));
    setOldList(JSON.parse(JSON.stringify(props.content.users)));
    setRoles(JSON.parse(JSON.stringify(props.content.roles)));
    if(props.content.count){
      setCount(JSON.parse(JSON.stringify(props.content.count)));
    }
    if(!props.content.hasOwnProperty("userList")){
      setLimit(10)
    }
  };

  const hasAction = (action) => {
    return props.widgets[0].config?.actions?.indexOf(action) > -1;
  };

  const createUser = async (item) => {
    props.changeLoader(true);
    let data = {};
    if (item) {
      data["item"] = item;
    }
    if(props.content.hasOwnProperty("userList")){
      data["userList"] = true
    }

    const as = (
      <MODALS.AddAbbUser
        pos={props.pos}
        catalogs={props.catalogs}
        changeAlert={props.changeAlert}
        changeLoader={props.changeLoader}
        contentModal={data}
        changePage={changePage}
        currentPage={currentPage}
        roles={roles}
        key="addAbbUser"
      />
    );
    openlightbox(as);

    props.changeLoader(false);
  };

  const editStatus = async (item, e) => {
    await updateUser(item, e.target.value)
  };

  const updateUser = async (item, status) => {
    props.changeLoader(true);
    let data = item
    data["status"] = status
    delete data["uuid"]
    data["email"] = item.admin.email
    
    let request = await API.service( "updateAbbUser", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200 && request.data.data.response == "OK") {
      await changePage(currentPage);
      props.changeAlert(true, "success", "Estatus actualizado con éxito.");
      props.changeLoader(false);
    } else {
      let detail = request.data.data.message;
      props.changeAlert(true, "error", "Error al editar estatus, " + detail);
      props.changeLoader(false);
    }
  };
  
  const deleteAbbUser = async (item) => {
    props.changeLoader(true);
    let data = {
      email: item.admin.email,
    };

    let request = await API.service( "deleteAbbUser", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200 && request.data.data.response == "OK") {
      await changePage(currentPage);
      props.changeAlert(true, "success", "Estatus actualizado con éxito.");
      props.changeLoader(false);
    } else {
      let detail = request.data.data.message;
      props.changeAlert(true, "error", "Error al editar estatus, " + detail);
      props.changeLoader(false);
    }
  }

  const filterData = async () => {
    let data = { 
      data: {
        filter: {},
        offset: 0,
        limit: limit
      }
    }
    if(search){
      data.data.filter["email"] = search.replace(/\s/g, '')
    }

    props.changeLoader(true);
    let request = await API.service( "adminAbbList", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200 && request.data.data.response == "OK") {
      let widget = request.data.data.widget[0]
      setList(JSON.parse(JSON.stringify(widget.data.content.documents)));
      setOldList(JSON.parse(JSON.stringify(widget.data.content.documents)));
      setCount(JSON.parse(JSON.stringify(widget.data.content.count)));
      setSearch("")
    }
    props.changeLoader(false);
  };

  const changeText = (e) => {
    setSearch(e.target.value);
  };
  const presDown = (e) => {
    if (e.key == "Enter") {
      filterData();
    }
  };

  const reloadData = async (data) => {
    props.changeLoader(true);
    let request = await API.service( "adminAbbList", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200 && request.data.data.response == "OK") {
      let widget = request.data.data.widget[0]
      setList(JSON.parse(JSON.stringify(widget.data.content.documents)));
      setOldList(JSON.parse(JSON.stringify(widget.data.content.documents)));
      setCount(JSON.parse(JSON.stringify(widget.data.content.count)));
    }
    props.changeLoader(false);
  };

  const dataReuse = async (uuid) => {
    props.changeLoader(true);

    let user = JSON.parse(localStorage.session);
    let data = {
      aql: `from data_reuse_afb where admin_uuid=${uuid}`,
      agent: user["uuid"]
    }

    let request = await API.service( "alboQueryLanguaje", data, props.pos, props.changeAlert, props.changeLoader, history );

    if (request.status === 200 && request.data.data.response === "OK") {
      await changePage(currentPage);
      props.changeAlert(true, "success", "Los datos del administrador fueron liberados exitosamente");
    } else {
      let detail = request.data.data.message;
      props.changeAlert(true, "error", "Error al ejecutar consulta: " + detail);
    }
    props.changeLoader(false);
  };

  const onInsertAlboToken = async () => {
    props.changeLoader(true);

    let user = JSON.parse(localStorage.session);
    let data = {
      aql: `from feature_insert_albo_token where uuids=${item.uuid}`,
      agent: user["uuid"]
    }

    let request = await API.service( "alboQueryLanguaje", data, props.pos, props.changeAlert, props.changeLoader, history );

    if (request.status === 200 && request.data.data.response === "OK") {
      await changePage(currentPage);
      props.changeAlert(true, "success", "La habilitación de albo Token se realizó exitosamente.");
    } else {
      let detail = request.data.data;
      detail["code"] === "0022.022.021" ?
      props.changeAlert(true, "error", "Error al ejecutar la acción: Ya existe un código activo.")
      :
      props.changeAlert(true, "error", "Error al ejecutar la acción: " + detail.code + detail.message)
    }
    props.changeLoader(false);
  };

  const onInsertAlboTokenByEmail = async () => {
    props.changeLoader(true);

    let user = JSON.parse(localStorage.session);
    let data = {
      aql: `from feature_insert_albo_token_by_email where uuids=${item.uuid}`,
      agent: user["uuid"]
    }

    let request = await API.service( "alboQueryLanguaje", data, props.pos, props.changeAlert, props.changeLoader, history );

    if (request.status === 200 && request.data.data.response === "OK") {
      await changePage(currentPage);
      props.changeAlert(true, "success", "El código de autenticación fue enviado correctamente.");
    } else {
      let detail = request.data.data;
      detail["code"] === "0022.022.021" ?
      props.changeAlert(true, "error", "Error al ejecutar la acción: Ya existe un código activo.")
      :
      props.changeAlert(true, "error", "Error al ejecutar la acción: " + detail.code + detail.message)
    }
    props.changeLoader(false);
  };

  const resendEmail = async (result) => {
    props.changeLoader(true);
    let user = JSON.parse(localStorage.session);

    let data = {
      session_uuid: result["session_uuid"],
      admin_uuid: item.uuid,
      inext_user: user['email']
    }

    let request = await API.service( "afbResendEmail", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status === 200 && request.data.data.response === "OK") {
      await changePage(currentPage);
      props.changeAlert(true, "success", "El correo fue enviado exitosamente.");
    } else {
      let detail = request.data.data.message;
      props.changeAlert(true, "error", "Error al ejecutar la acción: " + detail);
      props.changeLoader(false);
    }
    resetFields();
  };

  const resendEmailCS = async () => {
    props.changeLoader(true);
    let user = JSON.parse(localStorage.session);

    let data = {
      admin_uuid: item.uuid,
      inext_user: user['email'],
      auto_select_session: true
    }

    let request = await API.service( "afbResendEmail", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status === 200 && request.data.data.response === "OK") {
      await changePage(currentPage);
      props.changeAlert(true, "success", "El correo fue enviado exitosamente.");
    } else {
      let detail = request.data.data.message;
      props.changeAlert(true, "error", "Error al ejecutar la acción: " + detail);
      props.changeLoader(false);
    }
    resetFields();
  };

  const otpTokenGetAllowed = async (row, key) => {
    props.changeLoader(true);
    let data = {
      admin_uuid: row.uuid
    }

    let request = await API.service( "otpTokenGetAllowed", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status === 200 && request.data.data.response === "OK") {
      if(request.data.data.content["allowed"].indexOf("albo-token") === 0){
        props.changeLoader(false);
        return onOpenConfirm(row, key);
      } else {
        props.changeLoader(false);
        props.changeAlert(true, "error", "El usuario no posee token vinculado.");
      }
    } else {
      let detail = request.data["message"] || request.data.data["message"];
      props.changeAlert(true, "error", "Error al ejecutar la acción: " + detail);
      props.changeLoader(false);
    }
  };

  const otpTokenDisabledConfirm = async () => {
    props.changeLoader(true);

    let data = {
      admin_uuid: item.uuid,
      type: "albo-token"
    }

    let request = await API.service( "otpTokenDisabledConfirm", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status === 200 && request.data.data.response === "OK") {
      await changePage(currentPage);      
      props.changeAlert(true, "success", "La desvinculación se realizó de forma exitosa");
      props.changeLoader(false);
    } else {
      let detail = request.data["message"] || request.data.data["message"];
      props.changeAlert(true, "error", "Error al ejecutar la acción: " + detail);
      props.changeLoader(false);
    }
    resetFields();
  };


  const restoreSession = async (result) => {
    props.changeLoader(true);
    let user = JSON.parse(localStorage.session);
    let data = {
      admin_uuid: item.uuid,
      session_uuid: result["session_uuid"],
      inext_user: user['email'],
      action: result["action"]
    }

    let request = await API.service( "afbValidateSession", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status === 200 && request.data.data.response === "OK") {
      await changePage(currentPage);
      props.changeAlert(true, "success", "La acción fue ejecutada exitosamente.");
    } else {
      let detail = request.data.data.message;
      props.changeAlert(true, "error", "Error al ejecutar la acción: " + detail);
      props.changeLoader(false);
    }
    resetFields();
  };

  const showInfo = (item) => {
    return (
      <div style={{borderBottom: "1px solid rgba(0,0,0,.12)"}}>
        <DATA.InfoAbbUser content={item} roles={roles} changeLoader={props.changeLoader}/>
      </div>
    );
  };

  const columns = [];
  if (list) {
    columns.push(
      { selector: (row) => `${row.admin.gname} ${row.admin.lname} ${row.admin.slname}`, name: "Nombre",  wrap: true, sortable: true },
      { selector: (row) => row.admin.email, name: "Email",  wrap: true, sortable: true },
      { selector: (row) => row.admin.phone, name: "Teléfono", width:"15%", wrap: true, sortable: true },
      { cell: (row) => {
        return (
          <select value={row.status} onChange={editStatus.bind(this, row)} disabled={row.status == "disabled" ? true : false}>
            { status.map((item, index) => {
                return <option key={`state-${index}`} value={item.value}>
                  {item.label}
                </option>
              })
            }
          </select>
        )},
        name: "Estatus", wrap: true, sortable: true
      },
      { cell: (row) => {
        return (
          <>
            <div >
              {props.content.hasOwnProperty("userList") && row.status === "enabled" &&
                <Tooltip title="Vincular Empresa">
                  <IconButton onClick={createUser.bind(this, row)}>
                    <AddLink />
                  </IconButton>
                </Tooltip>       
              }   
              {hasAction('dataReuseAfb') && row.status === "disabled" && !row.admin.email.includes('_REUSADO') &&
                <Tooltip title="Liberar datos">
                  <IconButton onClick={dataReuse.bind(this, row.uuid)} sx={{paddingInline: "6px"}}>
                    <ContactPageSharp/>
                  </IconButton>
                </Tooltip>
              }
              {hasAction('resendEmail') &&
                <Tooltip title="Reenviar email 3FA">
                  <IconButton onClick={onOpenConfirm.bind(this, row, 'resendEmail')} sx={{paddingInline: "6px"}}>
                    <ForwardToInbox/>
                  </IconButton>
                </Tooltip>
              }
              {hasAction('resendEmailCS') &&
                <Tooltip title="Reenviar email 3FA">
                  <IconButton onClick={onOpenConfirm.bind(this, row, 'resendEmailCS')} sx={{paddingInline: "6px"}}>
                    <MarkEmailRead/>
                  </IconButton>
                </Tooltip>
              }
              {hasAction('restoreSession') &&
                <Tooltip title="Validar sesión">
                  <IconButton onClick={onOpenConfirm.bind(this, row, 'restoreSession')} sx={{paddingInline: "6px"}}>
                    <AdminPanelSettings/>
                  </IconButton>
                </Tooltip>
              }
              {hasAction('otpTokenGetAllowed') && row.status === "enabled" &&
                <Tooltip title="Desvincular albo token">
                  <IconButton onClick={otpTokenGetAllowed.bind(this, row, 'otpTokenDisabledConfirm')} sx={{paddingInline: "6px"}}>
                    <LeakRemove/>
                  </IconButton>
                </Tooltip>
              }
              {hasAction('alboToken') && row.status === "enabled" &&
                <Tooltip title="Habilitar albo token">
                  <IconButton onClick={onOpenConfirm.bind(this, row, 'onInsertAlboToken')} sx={{paddingInline: "6px"}}>
                    <AdbOutlined/>
                  </IconButton>
                </Tooltip>
              }
              {hasAction('alboTokenByEmail') && row.status === "enabled" &&
                <Tooltip title="Activar albo token vía Email">
                  <IconButton onClick={onOpenConfirm.bind(this, row, 'onInsertAlboTokenByEmail')} sx={{paddingInline: "6px"}}>
                    <QrCodeScanner/>
                  </IconButton>
                </Tooltip>
              }
            </div>
          </>
        )},
       sortable: true, name: "Acciones", minWidth: "250px"},
    )
  }

  const paginationComponentOptions = {
    rangeSeparatorText: "de",
    noRowsPerPage: true,
  };

  const changePage = async (value) => {
    let data = { 
      data: {
        filter: !props.content.hasOwnProperty("userList") ? { company_uuid: props.content.uuid} : {},
        offset: (value * limit) - limit,
        limit: limit
      }
    }
    setCurrentPage(value)
		await reloadData(data);
	};

  return (
    <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{borderColor: "#EDF0F4"}}> 
      <FlexGrid container fullWidth justify="space-between">
        <FlexGrid item>
          <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
            <People sx={{ marginRight: 1 }}/> Admins aFB
          </Typography>
        </FlexGrid>
        <FlexGrid container item spacing={2} style={{width: 520, paddingTop: 15, paddingBottom: 25}}>
          <TextField
              label={"Buscar usuario por email..."} color="secondary" size="small" fullWidth
              value={search} onChange={changeText.bind(this)} onKeyDown={presDown.bind(this)}
              InputProps={{endAdornment: (<IconButton onClick={filterData.bind(this)} ><Search/></IconButton>)}}
          />
          <IconButton onClick={createUser.bind(this, "")} sx={{padding: "0 !important"}} ><GroupAdd sx={{padding: "7px", borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: "#8bc179" }}/></IconButton>
        </FlexGrid>
      </FlexGrid>

      <ThemeProvider theme={theme}>
        <DataTable
          columns={columns}
          data={list}
          customStyles={customStyles2}
          expandableRows={props.content.hasOwnProperty("userList") ? true : false}
          expandOnRowClicked={false}
          expandableRowsComponent={showInfo}
          pagination          
          paginationServer
          paginationTotalRows={count}
          onChangePage={changePage}
          paginationPerPage={props.content.hasOwnProperty("userList") ? limit : 10}
          paginationComponentOptions={paginationComponentOptions}
          noDataComponent={noDataComponent}
        />
      </ThemeProvider>

      <GeneralConfirmDialog 
          open={dialogProps.open}
          text={dialogText}
          onClose={onCloseDialogConfirm} 
          onConfirm={onHandleConfirm.bind(this)} 
          item={item}
          element={element}
      />
    </Card>
  );
};

export default AdminAbbList;
